import { useMemo } from 'react';
import { useTranslation } from '@/i18n/i18n';
import { buildSignInUrl } from '@/lib/auth-url';

export function useSignInUrl() {
  const { locale } = useTranslation();

  return useMemo(() => buildSignInUrl(locale), [locale]);
}
